import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { listAdmins, normalizeAdminsListResponse } from '../services/admins';
import { adminQueryKeys } from './query-keys';

export const useAdminsQuery = (params = {}, options = {}) =>
  useQuery({
    queryKey: adminQueryKeys.users(params),
    queryFn: async () => {
      const result = await listAdmins(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch admin users');
      }
      return normalizeAdminsListResponse(result.data, params);
    },
    placeholderData: keepPreviousData,
    ...options,
  });
